<script lang="ts">
  import Button from '$lib/components/ui/button/button.svelte';
  import { formatDateDisplay } from '$lib/utils/utils';
  import { locale } from '$lib/i18n';

  let { date = $bindable(), toggleExpand, isExpanded }: { date: Date, toggleExpand?: (()=>void), isExpanded?: boolean } = $props();
</script>

<div class="field">
  <div>
    {formatDateDisplay(date, $locale)}
  </div>
  {#if toggleExpand}
  <div class="flex justify-left">
    <Button class="card-3d card-3d-anim" onclick={toggleExpand}>{isExpanded ? 'Collapse' : 'Expand'}</Button>
  </div>
  {/if}
</div>
